import store from "./store/store";
export default {
  name: "rsinject",
  routes: [],
  store: store,
};
